module.exports = __webpack_public_path__ + "img/icon_confirmation_password.84d7e601.svg";